export const CERTIFIED = 'certified';
export const RECERTIFY = 'recertify';
export const UNCERTIFIED = 'uncertified';
